import request from '@/util/axios'

export const login = data => {
    return request({
      url: "/api/Login/login",
      method: 'post',
      data
    })
}
export const sellerLogin = data => {
  return request({
    url: `/store/sellerAdmin/login/login`,
    method: 'post',
    data
  })
}
export const ChangePartnerCategory = data => {
  return request({
    url: `/store/sellerAdmin//Home/ChangePartnerCategory`,
    method: 'post',
    data
  })
}

//tag 获取商品分类
export const getCategories = data => {
  return request({
    url: "/api/Category/GetCategories",
    method: 'post',
    data
  })
}
//获取地区
export const getChildren = parent => {
  return request({
    url: "/common/RegionAPI/GetSubRegion",
    method: 'post',
    data:{
      parent
    }
  })
}

//上传图片
export const UploadPic = data => {
  return request({
    url: "/common/publicOperation/UploadPic",
    method: 'post',
    headers:{
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    data
  })
}

//上传视频
export const UploadVideo = data => {
  return request({
    url: "/common/publicOperation/UploadVideo",
    method: 'post',
    headers:{
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    data
  })
}
export const getRegionPage = data => {
  return request({
    url: "/common/PublicCommon/GetPaymentConfigPage",
    method: 'post',
    data
  })
}


//图形验证码校验
export const getImgCode = checkCode => {
  return request({
    url: "/store/register/CheckCheckCode",
    method: 'post',
    data:{
      checkCode
    }
  })
}
//获取改手机号是否注册
export const getPhone = mobile => {
  return request({
    url: "/store/Register/CheckMobile",
    method: 'post',
    data:{
      mobile
    }
  })
}

//发送短信
export const sendCode = (destination,imagecheckCode) => {
  return request({
    url: "/store/Register/SendCode",
    method: 'post',
    data:{
      destination,
      imagecheckCode,
      pluginId:'Jst.Plugin.Message.SMS'
    }
  })
}
//短信验证码校验
export const getCode = (destination,code) => {
  return request({
    url: "/store/register/CheckCode",
    method: 'post',
    data:{
      destination,
      code,
      pluginId:'Jst.Plugin.Message.SMS'
    }
  })
}
//用户新增
export const addUser = data => {
  return request({
    url: "/store/Register/RegisterUser",
    method: 'post',
    data
  })
}
//根据地区id 获取上级级联
export const getRegionTree = id => {
  return request({
    url: "/common/RegionAPI/GetRegionTree",
    method: 'post',
    data:{
      id
    }
  })
}


//入驻协议
export const getManagement = (url,data) => {
  return request({
      url: `${url}/ShopBranchCheckIn/GetManagement`,
      method: 'post',
      data
  })
}


//测试导出接口
export const exportExcel = data => {
  return request({
    url: `/store/SellerAdmin/Product/ShopProductDataImport`,
    method: 'post',
    data
  })
}


















